import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { buildAbsoluteAPIUrl } from '../../utils/urlUtils';
const GOOGLE_SHEETS_OAUTH_REFRESH_URL = '/googlesheets-integration/v1/oauth/refresh-status';
export const postRefreshStatus = () => http.post(buildAbsoluteAPIUrl({
  path: GOOGLE_SHEETS_OAUTH_REFRESH_URL,
  query: {
    portalId: PortalIdParser.get()
  }
}));